import create from 'zustand';
import { getUsers } from '../../api/users/users';
import { User } from '../../types/User';
import { useAuthStore } from '../auth/auth';
import { persist } from 'zustand/middleware';

interface UserStore {
    users: User[];
    loading: boolean;
    error: string | null;
    fetchUsers: () => Promise<void>;
}

export const useUserStore = create<UserStore>()(
    persist(
        (set, get) => ({
            users: [],
            loading: false,
            error: null,
            fetchUsers: async () => {
                const { SmartDVRToken, user } = useAuthStore.getState();

                if (!user || !SmartDVRToken) {
                    set({ error: 'User or token information is missing.' });
                    return;
                }

                set({ loading: true, error: null });

                try {
                    const users = await getUsers(SmartDVRToken, user.login);
                    set({ users, loading: false, error: null });
                } catch (error) {
                    console.error('Error fetching users:', error);
                    set({
                        loading: false,
                        error: error instanceof Error ? error.message : 'Failed to fetch users'
                    });
                }
            },
        }),
        {
            name: 'users-storage',
            partialize: (state) => ({ users: state.users }),
        },
    ),
);
